/**
 * The Flow Optimizer queue (bank-backed rotation: queue, promote, demote,
 * bank sync, rotation history, simulated stats) follows each tracker’s
 * capability. QueueProvider is the type every queue request takes; queueProviderOf
 * is the one way to get it from a tracker — null when that tracker has no
 * queue, so a queue request can never be built for it.
 * For Media Devoted | Created By Ciro Autiero
 */

import { matchTracker, trackerCan, type TrackerId } from '@trafficpulse/shared';

export type QueueProvider = TrackerId;

export function queueProviderOf(id: TrackerId): QueueProvider | null {
  const queue = matchTracker<QueueProvider | null>(id, {
    voluum: () => 'voluum',
    binom: () => 'binom',
    // Available only after the separate flowQueue capability flip.
    'tres-commas': () => 'tres-commas',
  });
  return queue && trackerCan(id, 'flowQueue') ? queue : null;
}

/** Restore synchronization follows each tracker's queue capability. */
export function queueRestoreProviderOf(id: TrackerId): QueueProvider | null {
  return matchTracker(id, {
    voluum: () => queueProviderOf(id),
    binom: () => queueProviderOf(id),
    'tres-commas': () => queueProviderOf(id),
  });
}
